module.exports = __webpack_public_path__ + "img/back-around-arrow.f903f556.svg";